import { useEffect } from 'react';
import SEOHead from '../../components/feature/SEOHead';
import SobreNavbar from './components/SobreNavbar';
import SobreHero from './components/SobreHero';
import TimelineHistoria from './components/TimelineHistoria';
import PropositoSection from './components/PropositoSection';
import ConquistasReconhecimentos from './components/ConquistasReconhecimentos';
import MissaoVisao from './components/MissaoVisao';
import NumerosJornadaPessoal from './components/NumerosJornadaPessoal';
import BiaNaMidia from './components/BiaNaMidia';
import DepoimentosSection from './components/DepoimentosSection';
import VideoDepoimentosSection from './components/VideoDepoimentosSection';
import ValoresSection from './components/ValoresSection';
import ParaQuemESection from './components/ParaQuemESection';
import EstatisticasImpacto from './components/EstatisticasImpacto';
import ComoFuncionaMetodo from './components/ComoFuncionaMetodo';
import FAQSobreSection from './components/FAQSobreSection';
import CTAFinalSobre from './components/CTAFinalSobre';
import SobreFooter from './components/SobreFooter';
import SocialShareBar from './components/SocialShareBar';
import InstagramGaleria from './components/InstagramGaleria';
import SectionNav from './components/SectionNav';
import ScrollToTop from './components/ScrollToTop';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const sobreSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Bia Holmes',
    url: `${SITE_URL}/sobre`,
    image: 'https://static.readdy.ai/image/9b313db6312c9605d9f9e3f145d3e29c/32f3bc36bea2a3e696d7bc6c9c1538c4.jpeg',
    jobTitle: 'Especialista em Transformação Pessoal e PNL',
    description: 'Fundadora do Carta do Eu Futuro. Especialista em PNL, gratidão e desenvolvimento pessoal. Transformou mais de 3.247 vidas com seu método exclusivo.',
    sameAs: ['https://www.instagram.com/bia.holmes'],
    nationality: {
      '@type': 'Country',
      name: 'Brasil',
    },
    knowsAbout: ['PNL', 'Programação Neurolinguística', 'Gratidão', 'Desenvolvimento Pessoal', 'Meditação', 'Transformação Pessoal'],
    worksFor: {
      '@type': 'Organization',
      name: 'Carta do Eu Futuro',
      url: SITE_URL,
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Sobre Bia Holmes | Carta do Eu Futuro',
    url: `${SITE_URL}/sobre`,
    inLanguage: 'pt-BR',
    description: 'Conheça Bia Holmes, fundadora do Carta do Eu Futuro. Especialista em PNL, gratidão e desenvolvimento pessoal que transformou mais de 3.247 vidas.',
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Início', item: SITE_URL },
        { '@type': 'ListItem', position: 2, name: 'Sobre', item: `${SITE_URL}/sobre` },
      ],
    },
    mainEntity: {
      '@type': 'Person',
      name: 'Bia Holmes',
    },
  },
];

const SobrePage = () => {
  useEffect(() => {
    if (typeof window !== 'undefined' && typeof window.scrollTo === 'function') {
      try {
        window.scrollTo(0, 0);
      } catch (e) {
        console.warn('Failed to scroll to top:', e);
      }
    }
  }, []);

  return (
    <main className="min-h-screen bg-luxury-black">
      <SEOHead
        title="Sobre Bia Holmes | Fundadora do Carta do Eu Futuro"
        description="Conheça Bia Holmes, especialista em PNL e desenvolvimento pessoal que transformou mais de 3.247 vidas. Descubra a história por trás do Carta do Eu Futuro."
        keywords="Bia Holmes, sobre a criadora, PNL, desenvolvimento pessoal, transformação pessoal"
        canonical="/sobre"
        ogImage="https://public.readdy.ai/ai/img_res/ec44c1d26697e7240fe8f5e196ef2bf0.jpg"
        ogType="website"
        schema={sobreSchema}
      />
      <SobreNavbar />
      <SectionNav />
      <div id="hero"><SobreHero /></div>
      <div id="timeline"><TimelineHistoria /></div>
      <div id="proposito"><PropositoSection /></div>
      <div id="conquistas"><ConquistasReconhecimentos /></div>
      <div id="missao"><MissaoVisao /></div>
      <div id="jornada"><NumerosJornadaPessoal /></div>
      <div id="midia"><BiaNaMidia /></div>
      <div id="depoimentos"><DepoimentosSection /></div>
      <div id="videos"><VideoDepoimentosSection /></div>
      <div id="valores"><ValoresSection /></div>
      <div id="para-quem"><ParaQuemESection /></div>
      <div id="estatisticas"><EstatisticasImpacto /></div>
      <div id="metodo"><ComoFuncionaMetodo /></div>
      <div id="faq"><FAQSobreSection /></div>
      <div id="instagram"><InstagramGaleria /></div>
      <div id="cta-final"><CTAFinalSobre /></div>
      <SobreFooter />
      <SocialShareBar />
      <ScrollToTop />
    </main>
  );
};

export default SobrePage;